import { debugPolicies } from './debug' // debug api policies
import { RequestPolicy } from './request'
import { RetryPolicy } from './retry'
import { createHooks } from './hooks'

// reexport event to be notified of any blacklisted api
export { onBucketsUpdate } from './buckets'

// reexport helper function to recognize trial errors
export { isTrialError } from './request'

/**
 * Request Policy for the WBS API
 * @see https://setplexapps.atlassian.net/wiki/spaces/MW/pages/3430776834/Request+Policy
 */
export const requestPolicy = new RequestPolicy()

/**
 * Retry Policy for the WBS API
 * @see https://setplexapps.atlassian.net/wiki/spaces/MW/pages/2682454084/Retry+Policy
 */
export const retryPolicy = new RetryPolicy(requestPolicy)

/**
 * Hooks to use in Merr client to apply Request and Retry Policies
 */
export const hooks = createHooks(requestPolicy, retryPolicy)

// debug api policies
debugPolicies(requestPolicy, retryPolicy)
